/* eslint-disable react/no-multi-comp */
import React, {
  useContext,
} from 'react';
import connect from '../../../../utils/connect';

import { Button } from '@app/ui';
import classNames from '@app/ui/sports-components/utils/classNames';

import { percentage, shortDate } from '../../../../utils/formatters';
import {
  getTextColor
} from '../../../../utils/getTextColor';
import { Client } from '../../../../types/api';
import { InVenueContext } from '../../../InVenue.context';

type GameViewProps = {
  date: string;
  analytics: {
    total: number;
    female: number;
    male: number;
  };
  client: Client
};

const GameView = ({
  date, analytics, client
}: GameViewProps) => {
  const {
    selectedDate,
    setSelectedDate
  } = useContext(InVenueContext);
  const isDateSelected = selectedDate === date;

  const onClick = () => {
    if (isDateSelected) {
      setSelectedDate(null);
    } else {
      setSelectedDate(date);
    }
  };


  const hasSelectedDate = !!selectedDate;
  const isDateUnselected = !isDateSelected && hasSelectedDate;

  const textColorFemale = getTextColor(client?.secondaryColor);
  const textColorMale = getTextColor(client?.primaryColor);

  const femalePercentage = percentage(analytics.total && analytics.female ? analytics.female / analytics.total : 0);
  const malePercentage = percentage(analytics.total && analytics.male ? analytics.male / analytics.total : 0);

  const dateClassNames = classNames(
    'gds-text--body-sm -m-l-2',
    {
      'gds-text--bold': isDateSelected
    }
  );

  const femaleProgressClassNames = classNames(
    'stadium-attendance-game-progress-female',
    {
      'stadium-attendance-game-progress-female-light': isDateUnselected
    }
  );

  const maleProgressClassNames = classNames(
    "stadium-attendance-game-progress-male",
    {
      "stadium-attendance-game-progress-male-light": isDateUnselected
    }
  );

  return (
    <div className="stadium-attendance-game">

      <div className="stadium-attendance-game-icon-container">
        <Button
          size="small"
          onClick={onClick}
          className="stadium-attendance-game-icon "
        >
          <i className="fa fas fa-eye" aria-hidden="true" data-test={
            `${date}#stadium-attendance-game-icon`
          } />
        </Button>
        <p className={dateClassNames}>
          {shortDate(date)}
        </p>
      </div>

      <div className="stadium-attendance-game-progress-container">
        <div className={
          femaleProgressClassNames
        } style={{
          width: femalePercentage
        }}>
          <p style={{
            color: textColorFemale
          }}>
            {femalePercentage}
          </p>
        </div>
        <div className={
          maleProgressClassNames
        } style={{
          width: malePercentage
        }}>
          <p style={{
            color: textColorMale
          }}>
            {malePercentage}
          </p>
        </div>
      </div>
    </div>
  );
};

export default connect(['client'])(GameView);
